import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const FretteSection = (): ReactElement => {
  const { t: tFrette } = useTranslation('', { keyPrefix: '$local.$fretteSection' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$fretteSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  return (
    <section className="base-section frette-section hp-section">
      {/* Frette Section */}
      <div className="main-hp hp-frette stack-float-wrapper">
        <Link href={tLinks('fretteMain')} id="HP_frette">
          <div id="hp-video">
            <video autoPlay muted playsInline loop preload="none" width={1280} height={562}>
              <source src="/video/homepage/stregis_frette.mp4" type="video/mp4" />
              <source src="/video/homepage/stregis-frette.webm" type="video/webm" />
              <source src="/video/homepage/stregis-frette.ogv" type="video/ogg" />
            </video>
          </div>
          <div className="stack-float">
            <p className="eyebrow">{tFrette('fretteEyebrow')}</p>
            <h2>
              {tFrette('fretteTitle')}
              <span className="st-regis">{tFrette('fretteStRegis')}</span>
            </h2>
            <p>{tFrette('fretteDescription')}</p>
            <span className="btn-main">{tButton('shopNow')}</span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default FretteSection;
